
import { Component, Vue } from "vue-property-decorator";
import RegisterComponent from "@/components/auth/RegisterComponent.vue";

@Component({
  components: {
    RegisterComponent
  },
  meta: {
    // sets document title
    title: "Registrar - Tarjeta Pircana",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Registrar Cuenta Tarjeta Pircana."
      },
      keywords: { name: "keywords", content: "Tarjeta Pircana" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class RegisterView extends Vue {}
